import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '../Flex';
import { Link } from '../Link';
import { Text } from '../Text';
import { refPropType } from '../utils';

function BreadcrumbLink(_ref) {
  var className = _ref.className,
      isLastChild = _ref.isLastChild,
      href = _ref.href,
      icon = _ref.icon,
      label = _ref.label,
      dsRef = _ref.dsRef,
      onClick = _ref.onClick;
  var linkColor = isLastChild ? 'text.dark' : 'text.light';
  return /*#__PURE__*/React.createElement(Flex, {
    className: className,
    alignItems: "center"
  }, icon, /*#__PURE__*/React.createElement(Link, {
    href: href,
    color: linkColor,
    onClick: onClick,
    dsRef: dsRef
  }, label), !isLastChild && /*#__PURE__*/React.createElement(Text, {
    m: 2,
    color: "text.light"
  }, "/"));
}

BreadcrumbLink.displayName = 'BreadcrumbLink';
BreadcrumbLink.propTypes = {
  className: PropTypes.string,
  isLastChild: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.node,
  label: PropTypes.string,
  dsRef: refPropType,
  onClick: PropTypes.func
};
BreadcrumbLink.defaultProps = {
  className: ''
};
export default BreadcrumbLink;